export enum Product {
  Acceptance = 'ACCEPTANCE',
  Disbursement = 'DISBURSEMENT',
}

export enum ProductStatus {
  NotSubmitted = 'NOT_SUBMITTED',
  Submitting = 'SUBMITTING',
  Submitted = 'SUBMITTED',
  NeedRevision = 'NEED_REVISION',
  TEMPORARILY_SUSPEND = 'TEMPORARILY_SUSPEND',
  Resubmitted = 'RESUBMITTED',
  KybApproved = 'KYB_APPROVED',
  LegalApproved = 'LEGAL_APPROVED',
  RiskApproved = 'RISK_APPROVED',
  Rejected = 'REJECTED',
  Blocked = 'BLOCKED',
}

export enum ProductValue {
  ApiDisbursement = 'API_DISBURSEMENT',
  BulkDisbursement = 'BULK_DISBURSEMENT',
  ApiOfflineCashOut = 'API_OFFLINE_CASH_OUT',
  ApiBiller = 'API_BILLER',
  PaymentCheckout = 'PAYMENT_CHECKOUT',
  ApiVirtualAccount = 'API_VIRTUAL_ACCOUNT',
  EWallet = 'EWALLET',
  ApiOfflineCashDeposit = 'API_OFFLINE_CASH_DEPOSIT',
  ApiInquiry = 'API_INQUIRY',
  TransactionData = 'TRANSACTION_DATA',
  OfflineServices = 'OFFLINE_SERVICES',
}
